import { showPopup } from "./popup";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoIcon from '@mui/icons-material/Info';
import { Button } from "@mui/joy";
import { getI18n } from "react-i18next";

const t = getI18n().t;

export const handleError = (errorType = 'unknown', errorMessage) => {
  switch (errorType) {
    case "otpRequestLimitReached":
      showPopup(getOTPLimitError(errorMessage));
      break;
    case "info":
      showPopup(getInfoModal(errorMessage));
      break;
    case "error":
      showPopup(getErrorModal(errorMessage));
      break;
    case "unknown":
      showPopup(getDefaultError(errorMessage));
      break;
    default:
      showPopup(getDefaultError(t, t('error')));
      break;
  }
};

function getOTPLimitError(errorMessage) {
  return {
    title: t('error'),
    titleIcon: <ErrorOutlineIcon sx={{color: 'var(--joy-palette-danger-500)'}} />,
    content: errorMessage,
    actions: (closePopup) => (
      <Button 
        variant="solid" 
        color="primary" 
        onClick={() => {
          closePopup();
        }}
      >
        {t('ok')}
      </Button>
    )
  };
}
function getDefaultError(errorMessage) {
  return {
    title: t('error'),
    titleIcon: <ErrorOutlineIcon sx={{color: 'var(--joy-palette-danger-500)'}} />,
    content: errorMessage,
    actions: (closePopup) => (
      <Button 
        variant="solid" 
        color="primary" 
        onClick={() => {
          closePopup();
        }}
      >
        {t('ok')}
      </Button>
    )
  };
}
function getInfoModal(message){
  return {
    title: t('info'),
    titleIcon: <InfoIcon sx={{color: 'var(--joy-palette-info-500)'}} />,
    content: message,
    actions: (closePopup) => (
      <Button 
        variant="solid" 
        color="primary" 
        onClick={() => {
          closePopup();
        }}
      >
        {t('ok')}
      </Button>
    )
  }
}
function getErrorModal(message){
  return {
    title: t('error'),
    titleIcon: <ErrorOutlineIcon sx={{color: 'var(--joy-palette-danger-500)'}} />,
    content: message,
    actions: (closePopup) => (
      <Button 
        variant="solid" 
        color="primary" 
        onClick={() => {
          closePopup();
        }}
      >
        {t('ok')}
      </Button>
    )
  }
}

export class AppError extends Error {
  constructor(type, message) {
    super(message);
    this.type = type;
    this.name = 'AppError';
    this.message = message;
  }

}